module.exports = __webpack_public_path__ + "WorkSans-Light.121d613863a872004b04.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Work_Sans/WorkSans-Light.ttf
// module id = ../../../../../src/assets/fonts_v2/Work_Sans/WorkSans-Light.ttf
// module chunks = styles